export default __webpack_public_path__ + "static/media/shopping-mall.ea8f4605.svg";